import React from 'react';
import './App.css';
import VideoConverter from './VideoConverter';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <VideoConverter />
      </header>
    </div>
  );
}

export default App;
